import { TranslateVariantIcon } from './TranslateVariantIcon';

/**
 * author: Michael Irigoyen
 * id F2BD1021-2575-4F57-A18A-F746EE262E15
 * name translate-variant
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/translate-variant.svg
 * tags
 * - Developer / Languages 
 */
export const SpokenLanguageIcon = TranslateVariantIcon;
export default SpokenLanguageIcon